import { apiSlice } from 'store/slices/api/api-slice';
import { ImageSuccessResponse } from 'types/card/card-sphere';
import { ItemImagesRequest } from 'types/toont-tint/tool-tint-item';

export const importTradeDataApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        toonTintItemMainImage: builder.mutation<
            ImageSuccessResponse,
            ItemImagesRequest
        >({
            query: (itemImagesRequest: ItemImagesRequest) => ({
                url:
                    `/toon-tint/add-category-item-main-image/` +
                    itemImagesRequest.itemId,
                method: 'POST',
                body: itemImagesRequest.image,
                header: {},
            }),
        }),

        toonTintItemMenuImage: builder.mutation<
            ImageSuccessResponse,
            ItemImagesRequest
        >({
            query: (itemImagesRequest: ItemImagesRequest) => ({
                url:
                    `/toon-tint/add-category-item-menu-image/` +
                    itemImagesRequest.itemId,
                method: 'POST',
                body: itemImagesRequest.image,
                header: {},
            }),
        }),
    }),
});

export const {
    useToonTintItemMainImageMutation,
    useToonTintItemMenuImageMutation,
} = importTradeDataApiSlice;
